<template>
    <div>
        <v-form>
            <v-row>
                <div class="title-wrapper">
                    <span class="display-1 font-weight-medium">Guardian Details</span>
                </div>
            </v-row>
            <br />
            <v-row>
                <v-col class="col-5">
                    <v-text-field
                        label="* First Name"
                        v-model="form.firstName"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col class="col-7">
                    <v-text-field
                        label="* Last Name"
                        v-model="form.lastName"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-4">
                    <v-text-field
                        label="Preferred Name"
                        v-model="form.preferredName"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col class="col-8">
                    <v-text-field
                        label="Address"
                        v-model="form.address"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-12">
                    <v-text-field
                        label="Email Address"
                        v-model="form.email"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-6">
                    <v-text-field
                        label="Home Phone"
                        v-model="form.homePhone"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col class="col-6">
                    <v-text-field
                        label="Mobile"
                        v-model="form.mobilePhone"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-12">
                    <v-select
                      :items="['email', 'sms']"
                      v-model="form.contactPreference"
                      label="Preferred Contact Method"
                      outlined
                    ></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-12">
                    <v-select
                      :items="['mother', 'father', 'grandmother', 'grandfather', 'aunty', '...']"
                      v-model="form.relationship"
                      label="Relationship"
                      outlined
                    ></v-select>
                </v-col>
            </v-row>
            <v-row style="text-align: center">
                <span class="form-header-padding headline font-weight-medium">Is your emergency contact the same? Y/N</span>
                <v-spacer></v-spacer>
                <v-btn-toggle
                  v-model="form.hasHadScholarship"
                  :value="false"
                  tile
                  color="deep-orange accent-3"
                  group
                >
                    <v-btn :value="true">
                        Yes
                    </v-btn>
                    <v-btn :value="false">
                        No
                    </v-btn>
                </v-btn-toggle>
            </v-row>
            <v-row v-if="form.hasHadScholarship">
                <v-col class="col-12">
                    <v-textarea
                      outlined
                      name="input-7-2"
                      v-model="form.scholarshipDescription"
                      label="Description"
                    ></v-textarea>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>
<script>
export default {
    data: function() {
        return {
            form: {
                firstName: null,
                lastName: null,
                preferredName: null,
                address: null,
                email: null,
                homePhone: null,
                mobilePhone: null,
                contactPreference: null,
                relationship: null
            }
        }
    }
}
</script>
